import React, { useState, useEffect, useCallback } from 'react';
import './App.css'; // Import the default styles
import { fetchAllPicks, fetchData } from './services/api';
import { doc, getFirestore, collection, getDocs, getDoc, query, where } from 'firebase/firestore';

const Group = ({ onPageChange, group, setGroup, setMatchup }) => {
    const [data, setPicks] = useState([]);
    const [week, setWeek] = useState(5);
    const [matchups, setMatchups] = useState([]);
    const [board, setBoard] = useState({});
    const [loading, setLoading] = useState(true);
    const [displayNames, setDisplayNames] = useState({});
    const [pics, setPics] = useState({});
    const [colors, setColors] = useState({});
    const [lastUpdateDate, setLastUpdateDate] = useState(""); 
    const [lastUpdateWeek, setLastUpdateWeek] = useState(""); 
    const [savedProfile, setSavedProfile] = useState(JSON.parse(localStorage.getItem('profile')) || {});

    useEffect(() => {
        
        const fetchData = async () => {
            try {
                if(group == null){
                    nullify();
                    return;
                }
                const firestore = getFirestore();

                // Step 1: Get emails of users in the group
                const userGroupsQuery = query(
                  collection(firestore, 'UserGroups'),
                  where('groupId', '==', group?.groupId)
                );
                const userGroupsSnapshot = await getDocs(userGroupsQuery);
                const userEmails = userGroupsSnapshot.docs.map(doc => doc.data().userEmail);

                // Step 2: Get all users
                const usersCollection = collection(firestore, 'Users');
                const usersSnapshot = await getDocs(usersCollection);
                const allUsers = usersSnapshot.docs.map(doc => doc.data());

                // Step 3: Filter users who are in the group
                const groupUsers = allUsers.filter(user => userEmails.includes(user.Email));

                // Set state
                setBoard(groupUsers);
                setLoading(false);
              } catch (error) {
                console.error('Error fetching data:', error);
              }
        };
        const fetchLastUpdate = async () => {
            try {
                const firestore = getFirestore();
                const connect = doc(firestore, 'LastUpdated', 'WeekPicks');
                const docSnapshot = await getDoc(connect);
                const Data = docSnapshot.data();
                const lud = Data["Date"];
                const luw = Data["Week"];
                setLastUpdateDate(lud);
                setLastUpdateWeek(luw);
            } catch (error) {
                console.error('Error fetching last update:', error);
            }
        };
        fetchLastUpdate();
        console.log("1");
        fetchData(); // Call the function to fetch data
    }, []);

    

    const currentDateTime = new Date().toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
    const nullify = () => {
    setGroup(null);
    onPageChange('groups');
}
if(group == null){
    nullify();
}

const viewMatchup = (matchup) => {
    setMatchup(matchup);
     onPageChange('matchup');
}


    return (
        
        <div className="page">
            <div className="backToGroups" onClick={() => nullify()}>
                <span className="reverse">&#10142;</span> &nbsp; Back to Groups
            </div>
            <div className="leaderboard">

                <h1>{group?.name}</h1>
{lastUpdateWeek > 0 || true ? (
                    <div>
                        {/*<div className="description">{lastUpdateWeek <19 ? `Games through Week ${lastUpdateWeek} - Updated on ${lastUpdateDate}` : ""}</div>*/}
       
                <table>
                    <thead>
                        <tr>
                            <th>RK</th>
                            <th>PLAYER</th>
                            <th>W</th>
                            <th>L</th>
                            <th>T</th>
                            <th>P</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && Object.keys(board).length === 0 ? (
                            <tr><td colSpan="4">Loading...</td></tr>
                        ) : (
                            Object.values(board)
                                //.filter(user => user["Points2025"] != null) // Filter users with points
                                //.filter(user => user["Analytics"] != true)
                                .sort((a, b) => {
                                    // First, sort by "Points", treating missing values as 0
                                    const pointsA = a["Points2026"] !== undefined && a["Points2026"] !== null ? a["Points2026"] : 0;
                                    const pointsB = b["Points2026"] !== undefined && b["Points2026"] !== null ? b["Points2026"] : 0;
                                    const pointsComparison = pointsB - pointsA;
                                    if (pointsComparison !== 0) {
                                        return pointsComparison;
                                    }

                                    // Sort by "Correct" next
                                    const correctA = a["Correct2026"] !== undefined && a["Correct2026"] !== null ? a["Correct2026"] : Number.MIN_SAFE_INTEGER;
                                    const correctB = b["Correct2026"] !== undefined && b["Correct2026"] !== null ? b["Correct2026"] : Number.MIN_SAFE_INTEGER;
                                    const correctComparison = correctB - correctA;

                                    if (correctComparison !== 0) {
                                        return correctComparison;
                                    }

                                    // Finally, sort by "Wrong"
                                    const wrongA = a["Wrong2026"] !== undefined && a["Wrong2026"] !== null ? a["Wrong2026"] : Number.MIN_SAFE_INTEGER;
                                    const wrongB = b["Wrong2026"] !== undefined && b["Wrong2026"] !== null ? b["Wrong2026"] : Number.MIN_SAFE_INTEGER;
                                    const wrongComparison = wrongA - wrongB;
                                    if (wrongComparison !== 0) {
                                        return wrongComparison;
                                    }

                                    // If points are equal, sort by "Order"
                                    const orderA = a["Order"] !== undefined && a["Order"] !== null ? a["Order"] : Number.MIN_SAFE_INTEGER;
                                    const orderB = b["Order"] !== undefined && b["Order"] !== null ? b["Order"] : Number.MIN_SAFE_INTEGER;
                                    const orderComparison = orderB - orderA;
                                    if (orderComparison !== 0) {
                                        return orderComparison;
                                    }

                                    // If both points and order are equal, sort by "Icon"
                                    return a["Name"].localeCompare(b["Name"]);
                                })
                                .map((user, index, array) => {
                                    const rank = index === 0 ? 1 : array[index - 1]["Points2025"] > user["Points2025"] ? index + 1 : index + 1;
                                    //const lastScore = index > 0 ? array[index - 1][1].points : null; // Initialize lastScore properly

                                    var isTied = index === 0
                                        ? false
                                        : (array[index - 1]["Points2026"] == user["Points2026"])
                                        || (array[index - 1]["Points2026"] === 0 && user["Points2026"] === undefined)
                                        || (array[index - 1]["Points2026"] === undefined && user["Points2026"] === 0);

                                    //const isTied = false;
                                    return (
                                        <tr key={user["Name"]} className={savedProfile.Email == user["Email"] ? "Highlighted" : ''}>
                                            <td>{!isTied ? rank : null}</td>
                                            <td>
                                                <span>
                                                    <span className={user["Color"]}>
                                                        { }
                                                        <img alt="Profile" src={`${user["Icon"]}.png`} />
                                                    </span>
                                                    {user["Name"]}
                                                </span>
                                            </td>
                                            <td>{user["Wins2026"] || 0}</td>
                                            <td>{user["Losses2026"] || 0}</td>
                                            <td>{user["Ties2026"] || 0}</td>
                                            <td>{user["Points2026"] || 0}</td>
                                            {/*<td>{Math.round(100*(user["Correct2026"] || 0)/Math.max(1, ((user["Correct2026"] || 0) + (user["Wrong2026"] || 0))))}%</td>*/}
                                            
                                        </tr>
                                    );
                                })
                        )}
                    </tbody>


                </table>
                       
                </div>
                )
                    : <div className="">Loading...</div>}
            </div>
             {/*<br />
            <div className="leaderboard">
              <h1>Week {week} Matchups</h1>

              <div className="matchups-list">
                {filteredMatchups.length === 0 && <p>No matchups for this week.</p>}

                {filteredMatchups.map((matchup, index) => (
                  <div key={index} className="matchup-row">
                    <div className="matchup-name">
                        <div className="team home">
                          {matchup.home === "BYE" ? (
                            <span className="bye">BYE</span>
                          ) : (
                            <span>{matchup.home}</span>
                          )}
                        </div>
                        <div className="vs">vs</div>
                        <div className="team away">
                          {matchup.away === "BYE" ? (
                            <span className="bye">BYE</span>
                          ) : (
                            <span>{matchup.away}</span>
                          )}
                        </div>
                    </div>
                    <div className="view-matchup">
                    <div className="view-matchup-button" onClick={() => viewMatchup(matchup)}>
                    View
                    </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>*/}

        </div>
    );
};

                                            export default Group;